import React, {useRef} from "react";
import useDialogBehavior from "./useDialogBehavior";
import "./SappmModal.css";

// Popup « Boussole SAPPM » de la landing : boîte de dialogue modale (focus piégé, reste de la page inerte, Échap) via
// useDialogBehavior, qui n'est actif que tant que la boîte est ouverte (d'où le composant interne).
export default function SappmModal({open, onClose, onLearnMore}) {
    return open ? <SappmDialog onClose={onClose} onLearnMore={onLearnMore}/> : null;
}

function SappmDialog({onClose, onLearnMore}) {
    const modalRef = useRef(null);
    useDialogBehavior(modalRef, onClose);

    return (
        <div className="sappm-modal-overlay" onClick={onClose}>
            <div
                className="sappm-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="sappm-modal-title"
                tabIndex={-1}
                ref={modalRef}
                onClick={e => e.stopPropagation()}
            >
                <button className="sappm-modal-close" onClick={onClose} aria-label="Fermer">✕</button>
                <p id="sappm-modal-title" className="sappm-modal-hook">
                    On vous a appris à servir l'intérêt général. Personne ne vous a dit qui veillerait sur le vôtre.
                </p>
                <p className="sappm-modal-body">
                    Le SAPPM défend les agents des SPM — pas seulement leurs dossiers, mais leur dignité et leur santé au travail.
                </p>
                <button className="sappm-modal-cta" onClick={onLearnMore}>En savoir plus →</button>
            </div>
        </div>
    );
}
